import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationGroup } from '../../../../types/location-group-response';

type CellParams = ICellRendererParams<LocationGroup> & {
  removeCallback: (item: LocationGroup) => void;
};

@Component({
  selector: 'app-pan-cell-locationgroup-list-actions',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule, SweetAlert2Module],
  templateUrl: './cell-locationgroup-list-actions.component.html',
  styleUrl: './cell-locationgroup-list-actions.component.scss',
})
export class CellLocationGroupListActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
